import { render, staticRenderFns } from "./OrderNotificationItem.vue?vue&type=template&id=17ea49f6"
import script from "./OrderNotificationItem.vue?vue&type=script&lang=js"
export * from "./OrderNotificationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports